import { render } from "./AccessDenied.vue?vue&type=template&id=6d71ce7e"
import script from "./AccessDenied.vue?vue&type=script&lang=js"
export * from "./AccessDenied.vue?vue&type=script&lang=js"
script.render = render

export default script